import React, { Component, Fragment } from 'react';

import Icon from 'components/icons';
import { I18n } from 'components/translate';
import { isMicrofront } from 'helpers/Microfront';
import throttle from 'lodash/throttle';
import { FIXED_BAR_ID } from 'modules/content/constants';
import {
  addScrollListener,
  executeWhenElChange,
  hideFixedActionsBar,
  removeScrollListener
} from 'modules/content/helper';
import PropTypes from 'prop-types';

export default class WebnarActions extends Component {
  static propTypes = {
    fixedBarId: PropTypes.string,
    formId: PropTypes.string,
    onCancel: PropTypes.func,
    onSaveAndReturn: PropTypes.func
  };

  static defaultProps = {
    fixedBarId: FIXED_BAR_ID
  };

  componentDidMount() {
    const { fixedBarId } = this.props;

    if (!isMicrofront()) {
      addScrollListener(
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        throttle(() => hideFixedActionsBar(fixedBarId), 200)
      );
      this.addDomChangesListener();
    }
  }

  componentWillUnmount() {
    const { fixedBarId } = this.props;

    if (!isMicrofront()) {
      removeScrollListener(
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        throttle(() => hideFixedActionsBar(fixedBarId), 200)
      );
      this.removeDomChangesListener();
    }
  }

  addDomChangesListener() {
    const { fixedBarId } = this.props;
    const observer = executeWhenElChange(
      'content',
      () => hideFixedActionsBar(fixedBarId),
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      300
    );

    this.setState({ observer });
  }

  removeDomChangesListener() {
    const { observer } = this.state;

    observer?.disconnect();
  }

  render() {
    const { formId, onSaveAndReturn, onCancel, fixedBarId } = this.props;

    return (
      <Fragment>
        <div
          id={fixedBarId}
          className="content__base__page__actions__backgroud"
        />
        <div className="content__base__page__actions action__buttons__wrapper mt__0">
          <button
            className="hot-button hot-button--primary hot-button--sm"
            type="submit"
            form={formId}
          >
            <Icon prefix="fal" iconName="check" className="_mr-2" />
            <I18n label="general.save" />
          </button>

          {onSaveAndReturn && (
            <button
              className="hot-button hot-button--secondary hot-button--sm"
              onClick={onSaveAndReturn}
              type="button"
            >
              <I18n label="general.save_and_return" />
            </button>
          )}

          <button
            className="hot-button hot-button--secondary hot-button--sm"
            onClick={onCancel}
            type="button"
          >
            <I18n label="general.cancel" />
          </button>
        </div>
      </Fragment>
    );
  }
}
